import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './WhatsAppChat.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import imgLogo from '../../assets/logo192.png';

const WHATSAPP_SVG = (
  <svg width="26" height="26" fill="white" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const WhatsAppChat = ({ phoneNumber, floatLabel, directLink = false, whatsappMessage }) => {
  const { t } = useTranslation();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [message, setMessage] = useState('Olá');
  const profileImage = imgLogo;

  const label = floatLabel ?? t('Chat with us!');
  const digits = phoneNumber.replace(/\D/g, '');
  const waText = encodeURIComponent(whatsappMessage ?? 'Olá');
  const waHref = `https://wa.me/${digits}?text=${waText}`;

  useEffect(() => {
    if (isChatOpen) setShouldRender(true);
  }, [isChatOpen]);

  const toggleChat = () => {
    if (!isChatOpen) {
      setIsChatOpen(true);
    } else {
      setIsChatOpen(false);
      setTimeout(() => setShouldRender(false), 300);
    }
  };

  const handleSendMessage = () => {
    if (message.trim()) {
      window.open(`https://wa.me/${digits}?text=${encodeURIComponent(message.trim())}`, '_blank');
      setIsChatOpen(false);
    }
    setMessage('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  const floatButton = directLink ? (
    <a
      href={waHref}
      className="wa-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
    >
      <span className="wa-ping" aria-hidden="true" />
      <span className="wa-ring" aria-hidden="true" />
      {WHATSAPP_SVG}
    </a>
  ) : (
    <button
      type="button"
      className="wa-btn"
      onClick={toggleChat}
      aria-label={label}
      aria-expanded={isChatOpen}
    >
      <span className="wa-ping" aria-hidden="true" />
      <span className="wa-ring" aria-hidden="true" />
      {WHATSAPP_SVG}
    </button>
  );

  return (
    <div className="whatsapp-chat-container">
      <div className={`wa-float${isChatOpen ? ' chat-open' : ''}`}>
        <span className="wa-lbl">{label}</span>
        {floatButton}
      </div>

      {!directLink && shouldRender && (
        <div className={`chat-window ${!isChatOpen ? 'closing' : ''}`}>
          <div className="chat-header">
            <div className="profile-info">
              <img src={profileImage} alt="Profile" className="profile-image" />
              <div className="profile-details">
                <span className="profile-name">{t('HF Assistance')}</span>
                <span className="profile-status">{t('Online')}</span>
              </div>
            </div>
            <div className="header-actions">
              <button type="button" className="close-button" onClick={toggleChat}>
                ×
              </button>
            </div>
          </div>
          <div className="chat-body">
            <div className="chat-message">
              <div className="chat-message-name">{t('HF Assistance')}</div>
              <div>{t('Hi! How can I help you?')}</div>
            </div>
          </div>
          <div className="chat-input">
            <input
              type="text"
              placeholder={t('Type a message')}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button
              type="button"
              className="send-button"
              onClick={handleSendMessage}
              disabled={!message.trim()}
            >
              <i className="fas fa-paper-plane" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppChat;
